import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { activeVersionAtom } from '../atoms/assistiveTouchAtoms';

/**
 * 分享项目路由决策组件
 * 根据当前激活的版本决定重定向到哪个版本的分享项目页面
 */
export const SharedProjectRouter: React.FC = () => {
  const { shareId } = useParams<{ shareId: string }>();
  const activeVersion = useAtomValue(activeVersionAtom);
  
  // 默认使用v3分享页面，但如果activeVersion是v0，则使用v0分享页面
  const targetPath = activeVersion === 'v0' 
    ? `/v0/s/project/${shareId}` 
    : `/v3/s/project/${shareId}`;
  
  return <Navigate to={targetPath} replace />;
};

export default SharedProjectRouter;
